import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.groovy = bracketIndenting()
